import jwtDecode from "jwt-decode";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { currencyToNumber } from "../../../../helpers/functions/currencyFormater";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import taService from "../services/ta.service";
import Collapse from "bootstrap/js/dist/collapse";

export default function useCreateTAOnboarding(active = {}) {
  const { Userdata = {}, id, taOnboardingCaseId } = active;
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const history = useHistory();
  const initialUpload = {
    aadhar_front: "",
    aadhar_back: "",
    pan: "",
    firm_pan: "",
    passport_photo: "",
    business_proof_1: "",
    business_proof_2: "",
    ksos_cheque_1: "",
    ksos_cheque_2: "",
    tyger_cheque_1: "",
    tyger_cheque_2: "",
    bank_statement: "",
    itr_year_1: "",
    itr_year_2: "",
    partnership_deed: "",
  };

  const initialValues = {
    taOnboardingCaseId: "",
    businessType: "",
    businessExperienceYears: "",
    noOfPartners: 0,
    companyName: "",
    taUserPhone: Userdata?.phone,
    personName: Userdata?.userName,
    officeType: "",
    yardDetails: "",
    email: "",
    companyAddress: "",
    vintageWithMeratractorYears: "",
    monthlyAverageSalesUnit: "",
    maritalStatusOfApplicant: "",
    residenceType: "",
    residentialStabilityYears: "",
    monthlyAverageSalesVolume: "",
    reference1Name: "",
    reference1Phone: "",
    reference2Name: "",
    reference2Phone: "",
    brokerBackground: "",
    dealingInList: "",
    yardForStocking: "",
    userPan: Userdata?.pan,
    associatedFinanciers: "",
    businessProof1Name: Userdata?.businessProof1Name,
    businessProof2Name: Userdata?.businessProof2Name,
    state: Userdata?.state_name,
    dealingInTractor: false,
    dealingInCv: false,
    dealingIn2w: false,
    recommendedAmount: "",
  };
  const [formUpload, setFormUpload] = useState(initialUpload);
  const [canAddPartner, setCanAddPartner] = useState(false);
  const [formData, setFormData] = useState(initialValues);
  const [selected, setSelected] = useState("buss");
  const [buttonLoader, setButtonLoader] = useState(false);

  const [loadingTADetails, setLoadingTADetails] = useState(false);

  const [ID, setId] = useState();

  useEffect(() => {
    if (id) {
      setId(id);
 
      // const taOnboardingFormData = JSON.parse(
      //   localStorage.getItem("taOnboardingFormData")
      // );
    } else if (taOnboardingCaseId) {

      setId(taOnboardingCaseId);
      // const taOnboardingFormData = JSON.parse(
      //   localStorage.getItem("taOnboardingFormData")
      // );
      // setFormData(taOnboardingFormData);
    } else {
      const taOnboardingFormData = JSON.parse(
        localStorage.getItem("taOnboardingFormData")
      );
      if (Userdata?.phone === taOnboardingFormData?.taUserPhone) {
        setFormData(taOnboardingFormData);
      } else {
        setFormData(initialValues);
      }

    }
  }, [id, taOnboardingCaseId]);

  const handleChangebussDetails = (e, name, type) => {
    if (e?.target) {
      const { name, value } = e.target;
      if (name === "dealingInList") {
        setFormData((prevData) => {
          const normalizedValues = (value || []).map((v) => v.toLowerCase());

          return {
            ...prevData,
            [name]: value,
            dealingInCv: normalizedValues.includes("cv") ? "True" : "False",
            dealingInTractor: normalizedValues.includes("tractor")
              ? "True"
              : "False",
            dealingIn2w:
              normalizedValues.includes("2w") ||
              normalizedValues.includes("2 wheeler")
                ? "True"
                : "False",
          };
        });
      } else if (name === "noOfPartners") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value !== "" ? parseInt(value) : "",
        }));
      } else if (name.startsWith("partner_")) {
        const [, index, field] = name.split("_");
        setFormData((prevData) => {
          const updatedPartners = [...prevData.partnerDetails];
          updatedPartners[Number(index) - 1] = {
            ...updatedPartners[Number(index) - 1],
            [field]: value?.trimStart(),
          };

          return { ...prevData, partnerDetails: updatedPartners };
        });
      } else if (name === "monthlyAverageSalesVolume") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: currencyToNumber(value),
        }));
      } else if (name === "businessType") {
        if (value === "Partnership" || value === "Private limited (Pvt Ltd)") {
          setFormData((prevData) => ({
            ...prevData,
            [name]: value?.trimStart(),
            partnerDetails: [
              {
                personName: "",
                phone: "",
                email: "",
                residenceType: "",
                businessExperienceYears: "",
                maritalStatusOfApplicant: "",
              },
            ],
          }));
        } else {
          setFormData((prevData) => ({
            ...prevData,
            [name]: value?.trimStart(),
          }));
        }
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value?.trimStart(),
        }));
      }
    } else if (e && name?.name) {
      const fieldName = name.name;

      const value = name?.isMulti ? e.map((opt) => opt.value) : e.value;

      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: value?.trimStart(),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const form = e.target;
      if (!form.checkValidity()) {
        const firstInvalid = form.querySelector(":invalid");
        if (firstInvalid) {
          const accordionItem = firstInvalid.closest(".accordion-item");

          if (accordionItem) {
            const collapse = accordionItem.querySelector(".accordion-collapse");
            if (collapse && collapse.id) {
              const bsCollapse = Collapse.getOrCreateInstance(collapse);

              bsCollapse.show();
              firstInvalid.focus();
            }
          }
        }
        form.reportValidity();
        return;
      }

      if (
        (formData?.businessType === "partnership" ||
          formData?.businessType === "pvt_ltd") &&
        formData?.noOfPartners === 0 &&
        formData?.partnerDetails.length === 0
      ) {
        errorToast("At least 1 partner is required");
        return;
      }
      if (formData?.dealingInList.length > 0) {
        e.preventDefault();
        let newFormData = {};
        if (
          formData?.taOnboardingCaseId !== "" ||
          formData?.taOnboardingCaseId !== undefined
        ) {
          newFormData = {
            taOnboardingCaseId: formData?.taOnboardingCaseId
              ? formData?.taOnboardingCaseId
              : "",
            ...(["individual", "proprietor"].includes(formData?.businessType)
              ? { pan: formData?.userPan }
              : { firmPan: formData?.firmPan }),
            businessType: formData.businessType,

            noOfPartners:
              formData?.partnerDetails?.length > 0
                ? formData?.partnerDetails?.length || 0
                : 0,
            businessExperienceYears: formData?.businessExperienceYears,
            companyName:
              ["proprietor", "partnership", "pvt_ltd"].includes(
                formData?.businessType
              ) && formData?.companyName,
            taUserPhone: formData?.taUserPhone,
            maritalStatusOfApplicant: formData?.maritalStatusOfApplicant,
            email: formData?.email,
            personName: formData?.personName,
            residenceType: formData?.residenceType,
            officeType: formData?.officeType,
            yardDetails: formData?.yardDetails,
            vintageWithMeratractorYears: formData?.vintageWithMeratractorYears,
            monthlyAverageSalesUnit: formData?.monthlyAverageSalesUnit,
            monthlyAverageSalesVolume: formData?.monthlyAverageSalesVolume,
            reference1Name: formData?.reference1Name,
            reference1Phone: formData?.reference1Phone,
            reference2Name: formData?.reference2Name,
            reference2Phone: formData?.reference2Phone,
            brokerBackground: formData?.brokerBackground,
            dealingInList: formData?.dealingInList,
            yardForStocking: formData?.yardForStocking,
            businessProof1Name: formData?.businessProof1Name,
            businessProof2Name: formData?.businessProof2Name,
            associatedFinanciers: formData?.associatedFinanciers,
            residentialStabilityYears: formData?.residentialStabilityYears,
            dealingIn2w: formData?.dealingIn2w,
            dealingInCv: formData?.dealingInCv,
            dealingInTractor: formData?.dealingInTractor,
            companyAddress: formData?.companyAddress,
            recommendedAmount: formData?.recommendedAmount,
            ...(["partnership", "pvt_ltd"].includes(formData?.businessType) && {
              partnerDetails: formData?.partnerDetails,
              noOfPartners: formData?.noOfPartners,
            }),
          };
        } else {
          newFormData = {
            pan: ["partnership", "pvt_ltd"].includes(formData?.businessType)
              ? formData?.firmPan
              : formData?.userPan,
            businessType: formData.businessType,
            partnerDetails:
              ["partnership", "pvt_ltd"].includes(formData?.businessType) &&
              formData?.partnerDetails,
            businessExperienceYears: formData?.businessExperienceYears,
            noOfPartners:
              formData?.partnerDetails?.length > 0
                ? formData?.partnerDetails?.length || 0
                : 0,
            companyName:
              ["proprietor", "partnership", "pvt_ltd"].includes(
                formData?.businessType
              ) && formData?.companyName,
            taUserPhone: formData?.taUserPhone,
            email: formData?.email,
            personName: formData?.personName,
            residenceType: formData?.residenceType,
            maritalStatusOfApplicant: formData?.maritalStatusOfApplicant,
            officeType: formData?.officeType,
            yardDetails: formData?.yardDetails,
            companyAddress: formData?.companyAddress,
            vintageWithMeratractorYears: formData?.vintageWithMeratractorYears,
            monthlyAverageSalesUnit: formData?.monthlyAverageSalesUnit,
            monthlyAverageSalesVolume: formData?.monthlyAverageSalesVolume,
            reference1Name: formData?.reference1Name,
            reference1Phone: formData?.reference1Phone,
            reference2Name: formData?.reference2Name,
            reference2Phone: formData?.reference2Phone,
            brokerBackground: formData?.brokerBackground,
            yardForStocking: formData?.yardForStocking,
            associatedFinanciers: formData?.associatedFinanciers,
            residentialStabilityYears: formData?.residentialStabilityYears,
            dealingIn2w: formData?.dealingIn2w,
            dealingInCv: formData?.dealingInCv,
            dealingInTractor: formData?.dealingInTractor,
            recommendedAmount: formData?.recommendedAmount,
          };
        }

        let response = "";

        setButtonLoader(true);
        if (taOnboardingCaseId && taOnboardingCaseId !== "") {
          response = await taService.UpdateTAUser(newFormData);
        } else {
          response = await taService.CreateTAUser(newFormData);
        }
        setButtonLoader(false);
        if (response && response.status === 200) {
          successToast(response.msg);
          localStorage.removeItem("taOnboardingFormData");
          if (taOnboardingCaseId && taOnboardingCaseId !== "") {
            history.push(
              `/auction_representative/user_home/manage-ta-onboard-id:${taOnboardingCaseId}`
            );
          } else {
            history.push(
              `/auction_representative/user_home/manage-ta-onboard-id:${response?.taOnboardingCaseId}`
            );
          }
        } else {
          errorToast(response.msg);
        }
      } else {
        errorToast(
          "before submit the form please select Dealing In (Vehicle category)"
        );
      }
    } catch (error) {
      console.error(error);

      errorToast(error?.message);
    }
  };

  useEffect(() => {
    if (ID !== undefined || ID !== null || ID !== "") {

      const fetchData = async () => {
        try {
          setLoadingTADetails(true);
          const formData = new FormData();
          formData.append("taOnboardingCaseId", ID);
          const response = await taService.GetTACaseDetails(formData);
          if (response?.status === 200) {
            if (
              response?.data?.isCaseBusinessDetailsRejectedByBa &&
              user?.role === "Auction Representative"
            ) {
              history?.push(
                `/auction_representative/user_home/manage-ta-onboard/update-ta-user:${response?.data?.taOnboardingCaseId}`
              );

              setFormData((prev) => ({
                ...prev,
                ...response.data,
                userPan: response?.data?.pan,
                noOfPartners: response?.data?.partnerDetails?.length || 0,
              }));

              setLoadingTADetails(false);
            } else {
              setFormData((prev) => ({
                ...prev,
                ...response.data,
                userPan: response?.data?.pan,
                noOfPartners: response?.data?.partnerDetails?.length || 0,
              }));

              setLoadingTADetails(false);
            }
          } else {
            setLoadingTADetails(false);
            errorToast(response?.msg);
          }
        } catch (error) {
          errorToast(error?.msg || "Something went wrong");
          setLoadingTADetails(false);
        }
      };

      if (ID) {
        fetchData();
      }
    }
  }, [ID]);

  const handleDeletePartner = async (e, id, partnerID) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this partner's details?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        focusCancel: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();
          formData.append("partnerId", partnerID);
          formData.append("taOnboardingCaseId", id);

          try {
            const response = await taService.DeletePartnerById(formData);
            if (response?.status === 200) {
              successToast(response?.msg);
              setLoadingTADetails(true);
              const formData = new FormData();
              formData.append("taOnboardingCaseId", id);
              const res = await taService.GetTACaseDetails(formData);
              if (res?.status === 200) {
                setFormData((prev) => ({
                  ...prev,
                  ...res?.data,
                  noOfPartners: res?.data?.partnerDetails?.length || 0,
                }));

                setLoadingTADetails(false);
              } else {
                setLoadingTADetails(false);
                errorToast(res?.msg);
              }
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.error("Error deleting partner:", error);
      errorToast("An error occurred while deleting the partner.");
    }
  };

  const handleClear = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to reset form data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Reset it!",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise((resolve) => {
          // Simulate async deletion
          setTimeout(() => {
            setFormData(initialValues);
            resolve();
          }, 1000); // 1-second delay to simulate loading
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("reset!", "The form data remove.", "success");
      }
    });
  };

  const handleAddPartner = () => {
    setFormData((prevData) => {
      const updatedPartnerDetails = [
        ...(prevData.partnerDetails || []),
        {
          personName: "",
          phone: "",
          email: "",
          residenceType: "",
          businessExperienceYears: "",
          maritalStatusOfApplicant: "",
        },
      ];
      return {
        ...prevData,
        partnerDetails: updatedPartnerDetails,
        noOfPartners: updatedPartnerDetails.length,
      };
    });
  };

  useEffect(() => {

    localStorage.setItem(
      "taOnboardingFormData",
      formData ? JSON.stringify(formData) : formData
    );
  }, [formData]);

  return {
    formData,
    setFormData,
    handleSubmit,
    setSelected,
    selected,
    buttonLoader,
    loadingTADetails,
    handleChangebussDetails,
    handleClear,
    handleDeletePartner,
    handleAddPartner,
  };
}
